<template>
    <v-snackbar v-model="msg.show" :timeout="msg.timeout" :color="msg.color"
                transition="slide-y-reverse-transition" vertical
                style="position: fixed; bottom: 10px;">
                <p v-if="msg.header" class="subtitle-1 mb-2">{{msg.header}}</p>
                {{msg.text}}
        <template v-if="msg.actionButtonI18n" v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="msg.actionMethod()" @click.stop>
                {{msg.actionButtonI18n}}
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
    export default {
        name: "snackbar",
        props: ['msg'],
        methods: {
            close(){this.$emit('close')}
        }
    }
</script>

<style scoped>

</style>